





















import { defineComponent } from '@vue/composition-api';
import { trackEvent } from '@tt4b/ttam-utils';
import QuestionTooltip from 'src/components/common/question-tooltip/index.vue';

const name = 'ttam-audience-size-flex-main-title';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  setup() {
    const trackClick = () => {
      trackEvent('create_AS_learnMore_click');
    };
    return {
      name,
      trackClick,
    };
  },
});
